import { randomInt } from "./helpers/helpers";

export const API_URL = import.meta.env.REACT_APP_API_URL;
export const API_DEBUG = import.meta.env.REACT_APP_API_DEBUG === "true";

export const ROLES = [
    "ROLE_ADMIN",
    "ROLE_ARMATEUR",
    "ROLE_COMPTABLE",
    "ROLE_NAVIGANT",
    "ROLE_SUPER_ADMIN",
    "ROLE_SUPER_COMPTABLE",
    "ROLE_TECHNICIEN",
];

// export const CONNECTOR_TYPES = ['ALL', 'Electricity', '400A', '125A', '63A', '32A', '16A', 'Water']
export const CONNECTOR_TYPES = [
    "ALL",
    "Electricity",
    "63A",
    "32A",
    "16A",
    "Water",
];

export const COUNTRIES = [
    "Afghanistan",
    "Albania",
    "Antarctica",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Azerbaijan",
    "Argentina",
    "Australia",
    "Austria",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Armenia",
    "Barbados",
    "Belgium",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "Belize",
    "British Indian Ocean Territory",
    "Solomon Islands",
    "British Virgin Islands",
    "Brunei Darussalam",
    "Bulgaria",
    "Myanmar",
    "Burundi",
    "Belarus",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African",
    "Sri Lanka",
    "Chad",
    "Chile",
    "China",
    "Taiwan",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Mayotte",
    "Republic of the Congo",
    "The Democratic Republic Of The Congo",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Benin",
    "Denmark",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "El Salvador",
    "Equatorial Guinea",
    "Ethiopia",
    "Eritrea",
    "Estonia",
    "Faroe Islands",
    "Falkland Islands",
    "South Georgia and the South Sandwich Islands",
    "Fiji",
    "Finland",
    "Åland Islands",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Djibouti",
    "Gabon",
    "Georgia",
    "Gambia",
    "Occupied Palestinian Territory",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Kiribati",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Vatican City State",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Islamic Republic of Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Côte d'Ivoire",
    "Jamaica",
    "Japan",
    "Kazakhstan",
    "Jordan",
    "Kenya",
    "Democratic People's Republic of Korea",
    "Republic of Korea",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Lebanon",
    "Lesotho",
    "Latvia",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Monaco",
    "Mongolia",
    "Republic of Moldova",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Oman",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "Aruba",
    "New Caledonia",
    "Vanuatu",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Norway",
    "Northern Mariana Islands",
    "United States Minor Outlying Islands",
    "Federated States of Micronesia",
    "Marshall Islands",
    "Palau",
    "Pakistan",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Guinea-Bissau",
    "Timor-Leste",
    "Puerto Rico",
    "Qatar",
    "Réunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Helena",
    "Saint Kitts and Nevis",
    "Anguilla",
    "Saint Lucia",
    "Saint-Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Vietnam",
    "Slovenia",
    "Somalia",
    "South Africa",
    "Zimbabwe",
    "Spain",
    "Western Sahara",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Tajikistan",
    "Thailand",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "United Arab Emirates",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "The Former Yugoslav Republic of Macedonia",
    "Egypt",
    "United Kingdom",
    "Isle of Man",
    "United Republic Of Tanzania",
    "United States",
    "U.S. Virgin Islands",
    "Burkina Faso",
    "Uruguay",
    "Uzbekistan",
    "Venezuela",
    "Wallis and Futuna",
    "Samoa",
    "Yemen",
    "Serbia and Montenegro",
    "Zambia",
];

export const LANGUAGES = [
    { value: "fr", name: "Français" },
    { value: "en", name: "English" },
];

export const MENU_DATA = [
    { id: 1, name: "home_statistics", roles: [], to: "/" },
    {
        id: 2,
        name: "terminals",
        roles: [
            "ROLE_TECHNICIEN",
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
            "ROLE_ARMATEUR",
            "ROLE_NAVIGANT",
        ],
        to: "/terminal",
    },
    { id: 3, name: "transaction_history", roles: [], to: "/transaction" },
    {
        id: 4,
        name: "ships",
        roles: ["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ARMATEUR"],
        to: "/ship",
    },
    {
        id: 5,
        name: "tickets",
        roles: [
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
            "ROLE_ARMATEUR",
            "ROLE_NAVIGANT",
        ],
        to: "/ticket",
    },
    { id: 6, name: "updates_note", roles: [], to: "/update_note" },
    { id: 7, name: "procedures", roles: [], to: "/procedures" },
    {
        id: "s1",
        separator: true,
        roles: [
            "ROLE_SUPER_COMPTABLE",
            "ROLE_TECHNICIEN",
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
        ],
    },
    {
        id: 8,
        name: "administration",
        roles: [
            "ROLE_SUPER_COMPTABLE",
            "ROLE_TECHNICIEN",
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
        ],
        children: [
            {
                id: 9,
                name: "users",
                roles: ["ROLE_ADMIN", "ROLE_SUPER_ADMIN"],
                to: "/user",
            },
            {
                id: 10,
                name: "boat_owners",
                roles: [
                    "ROLE_SUPER_COMPTABLE",
                    "ROLE_ADMIN",
                    "ROLE_SUPER_ADMIN",
                ],
                to: "/usager",
            },
            /*{
                id: 11,
                name: "tariffs",
                roles: ["ROLE_ADMIN", "ROLE_SUPER_ADMIN"],
                to: "/tariff",
            },*/
            {
                id: 11,
                name: "remote_operations",
                roles: ["ROLE_TECHNICIEN", "ROLE_ADMIN", "ROLE_SUPER_ADMIN"],
                children: [
                    {
                        id: 12,
                        name: "start_a_distribution",
                        roles: [
                            "ROLE_TECHNICIEN",
                            "ROLE_ADMIN",
                            "ROLE_SUPER_ADMIN",
                        ],
                        to: "/operation/start_distribution",
                    },
                    {
                        id: 13,
                        name: "stop_a_distribution",
                        roles: [
                            "ROLE_TECHNICIEN",
                            "ROLE_ADMIN",
                            "ROLE_SUPER_ADMIN",
                        ],
                        to: "/operation/stop_distribution",
                    },
                    {
                        id: 14,
                        name: "reserve_a_connector",
                        roles: [
                            "ROLE_TECHNICIEN",
                            "ROLE_ADMIN",
                            "ROLE_SUPER_ADMIN",
                        ],
                        to: "/operation/reserve_connector",
                    },
                    {
                        id: 15,
                        name: "cancel_a_reservation",
                        roles: [
                            "ROLE_TECHNICIEN",
                            "ROLE_ADMIN",
                            "ROLE_SUPER_ADMIN",
                        ],
                        to: "/operation/cancel_reservation",
                    },
                    {
                        id: 16,
                        name: "restart_a_terminal",
                        roles: [
                            "ROLE_TECHNICIEN",
                            "ROLE_ADMIN",
                            "ROLE_SUPER_ADMIN",
                        ],
                        to: "/operation/restart_terminal",
                    },
                ],
            },
        ],
    },
    { id: "s2", separator: true },
];

export const REACT_TOUR_CONFIG = {
    steps: [],
    padding: { mask: 0, popover: [20, 20] },
    disableInteraction: true,
    onClickHighlighted: (e) => e.stopPropagation(),
    onClickMask: () => false,
    scrollSmooth: true,
};

export const REACT_TOUR_STEPS = [
    {
        selector: ".tour--home_statistics",
        navigationOpen: true,
        roles: [],
        position: "right",
        content: "tour_content_statistics",
    },
    {
        selector: ".tour--terminals",
        navigationOpen: true,
        roles: [
            "ROLE_TECHNICIEN",
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
            "ROLE_ARMATEUR",
            "ROLE_NAVIGANT",
        ],
        position: "right",
        content: "tour_content_terminals",
    },
    {
        selector: ".tour--transaction_history",
        navigationOpen: true,
        roles: [],
        position: "right",
        content: "tour_content_transaction_history",
    },
    {
        selector: ".tour--ships",
        navigationOpen: true,
        roles: ["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_ARMATEUR"],
        position: "right",
        content: "tour_content_ships",
    },
    {
        selector: ".tour--tickets",
        navigationOpen: true,
        roles: [
            "ROLE_ADMIN",
            "ROLE_SUPER_ADMIN",
            "ROLE_ARMATEUR",
            "ROLE_NAVIGANT",
        ],
        position: "right",
        content: "tour_content_tickets",
    },
    {
        selector: ".tour--updates_note",
        navigationOpen: true,
        roles: [],
        position: "right",
        content: "tour_content_updates_note",
    },
    {
        selector: ".tour--procedures",
        navigationOpen: true,
        roles: [],
        position: "right",
        content: "tour_content_procedures",
    },
    {
        selector: ".tour--account",
        navigationOpen: false,
        roles: [
            "ROLE_ADMIN",
            "ROLE_ARMATEUR",
            "ROLE_COMPTABLE",
            "ROLE_SUPER_ADMIN",
            "ROLE_SUPER_COMPTABLE",
            "ROLE_TECHNICIEN",
        ],
        content: "tour_content_account",
    },
    {
        navigationOpen: false,
        roles: [],
        position: "center",
        content: "tour_content_pwa",
    },
];

// =====================================================================================
// FAKE DATA FOR DEVELOPPING PURPOSES => REMOVE AS SOON AS IT'S NOT NEEDED ANYMORE
// =====================================================================================

export const FAKE_DATAVIZ_DATA_1 = [
    {
        id: "available",
        label: "available",
        value: 19,
        color: "hsl(145, 60%, 43%)",
    },
    {
        id: "occupied",
        label: "occupied",
        value: 6,
        color: "hsl(204, 64%, 44%)",
    },
    {
        id: "faulted",
        label: "faulted",
        value: 3,
        color: "hsl(6, 63%, 46%)",
    },
];

export const FAKE_DATAVIZ_DATA_2 = [
    {
        id: "available",
        label: "available",
        value: 12,
        color: "hsl(145, 60%, 43%)",
    },
    {
        id: "occupied",
        label: "occupied",
        value: 2,
        color: "hsl(204, 64%, 44%)",
    },
];

export const FAKE_DATAVIZ_DATA_3 = [
    {
        date: "Juin 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Juillet 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Aout 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Septembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Octobre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Novembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Decembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Janvier 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Fevrier 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Mars 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Avril 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Mai 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Juin 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
];

export const FAKE_DATAVIZ_DATA_4 = [
    {
        date: "Juin 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Juillet 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Aout 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Septembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Octobre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Novembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Decembre 2020",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Janvier 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Fevrier 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Mars 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Avril 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Mai 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
    {
        date: "Juin 2021",
        "Nb de distributions d'électricité": randomInt(0, 20),
        "Nb de distributions d'électricité à zero kW": randomInt(0, 20),
        "Nb de distributions d'électricité en cours": randomInt(0, 20),
    },
];

export const FAKE_DATAVIZ_DATA_5 = [
    {
        id: "Conso. électrique (kWh)",
        data: [
            {
                x: "Juillet 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Aout 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Septembre 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Octobre 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Novembre 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Decembre 2020",
                y: randomInt(0, 12000),
            },
            {
                x: "Janvier 2021",
                y: randomInt(0, 12000),
            },
            {
                x: "Fevrier 2021",
                y: randomInt(0, 12000),
            },
            {
                x: "Mars 2021",
                y: randomInt(0, 12000),
            },
            {
                x: "Avril 2021",
                y: randomInt(0, 12000),
            },
            {
                x: "Mai 2021",
                y: randomInt(0, 12000),
            },
            {
                x: "Juin 2021",
                y: randomInt(0, 12000),
            },
        ],
    },
];

export const FAKE_DATAVIZ_DATA_6 = [
    {
        id: (
            <>
                Conso. eau (m<sup>3</sup>)
            </>
        ),
        data: [
            {
                x: "Juillet 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Aout 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Septembre 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Octobre 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Novembre 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Decembre 2020",
                y: randomInt(0, 200),
            },
            {
                x: "Janvier 2021",
                y: randomInt(0, 200),
            },
            {
                x: "Fevrier 2021",
                y: randomInt(0, 200),
            },
            {
                x: "Mars 2021",
                y: randomInt(0, 200),
            },
            {
                x: "Avril 2021",
                y: randomInt(0, 200),
            },
            {
                x: "Mai 2021",
                y: randomInt(0, 200),
            },
            {
                x: "Juin 2021",
                y: randomInt(0, 200),
            },
        ],
    },
];

export const DEFAULT_LAYOUT_LG = [
    {
        w: 6,
        h: 1,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 6,
        y: 0,
        i: "1",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 1,
        i: "2",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 6,
        y: 1,
        i: "3",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 2,
        i: "4",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 6,
        y: 2,
        i: "5",
        moved: false,
        static: false,
    },
];

export const DEFAULT_LAYOUT_SM = [
    {
        w: 6,
        h: 1,
        x: 0,
        y: 0,
        i: "0",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 1,
        i: "1",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 2,
        i: "2",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 3,
        i: "3",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 4,
        i: "4",
        moved: false,
        static: false,
    },
    {
        w: 6,
        h: 1,
        x: 0,
        y: 5,
        i: "5",
        moved: false,
        static: false,
    },
];
